import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';
import { IDict } from '../types/utility';
export default function getFeatureConfig(
    messageBus: SDKMessageBus,
    moduleId: string,
    requestedConfigurations: Set<string>
) {
    if (!requestedConfigurations.has('getFeatureConfig')) {
        return;
    }

    return function(): Promise<IDict<any>> {
        return messageBus
            .sendRequest<{ config: IDict<any> }>(
                'getFeatureConfig',
                Maybe.just(JSON.stringify({ moduleId }))
            )
            .then(response => response.value.config);
    };
}
